import MenuPageLayout from "@/components/layouts/MenuPageLayout";
import { useAppContext } from "@/contexts/app-context";
import { WordsLearnedChart } from "@/components/charts/words-learned-chart";
import { SongPlaysChart } from "@/components/charts/song-plays-chart";
import { TimePlayedChart } from "@/components/charts/time-played-chart";

const SettingsPage = () => {
  const { state: { currentUser, isLoadingCurrentUser, selectedChildId } } = useAppContext();

  return (
    <MenuPageLayout title="Reports" className="relative overflow-clip">
      {!isLoadingCurrentUser && (
        <>
          <div className="grid lg:grid-cols-1 gap-4 w-full max-w-screen-lg">
            <section className="flex flex-col gap-y-2 overflow-hidden">
              <h2 className="text-2xl">Number of words learned per week</h2>
              <WordsLearnedChart childId={selectedChildId} demo={!currentUser?.entitlements.includes("reports")} />
            </section>

            <section className="flex flex-col gap-y-2 overflow-hidden">
              <h2 className="text-2xl">Time played for all songs (in minutes)</h2>
              <TimePlayedChart childId={selectedChildId} demo={!currentUser?.entitlements.includes("reports")} />
            </section>

            <section className="flex flex-col gap-y-2 overflow-hidden">
              <h2 className="text-2xl">Total song plays / Total completed</h2>
              <SongPlaysChart childId={selectedChildId} demo={!currentUser?.entitlements.includes("reports")} />
            </section>
          </div>

          {!currentUser?.entitlements.includes("reports") && (
            <div className="absolute inset-0 bg-black/25 backdrop-blur-[2px] pt-8 px-4 flex justify-center items-start">
              <div className="absolute top-[calc(50vh-232px)] inset-x-4 mx-auto bg-white p-8 rounded-lg ring-4 ring-amber-400 flex flex-col gap-y-4 items-center w-[500px] max-w-[calc(100%-2rem)] text-center">
                Upgrade to Premium to access your reports.
              </div>
            </div>
          )}
        </>
      )}
    </MenuPageLayout>
  );
};

export default SettingsPage;
